import xhr from '../utilities/xhr';
import unsetUser from './user/unsetUser';
import {
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import {clearAllElusiveData} from '~/frontend/src/actions/elusiveData';
import {AxiosResponse} from 'axios';

/**
 * @memberOf! Actions
 *
 * @return {function}
 */
const logout = () : Thunk<Promise<void>> => async ( dispatch : AppDispatch ) : Promise<void> => {
    let res : AxiosResponse<any> | null = null;

    try {
        res = await xhr.get( `${BASE_URL}/logout`, undefined, undefined, undefined, dispatch )
    }
    catch ( error ) {
        console.log( error );
    }

    if ( res?.data.success ) {
        const userId = global.user ? global.user.userId : '';

        dispatch( unsetUser() );
        dispatch( clearAllElusiveData() );

        if ( userId ) {
            localStorage.setItem( 'lastUser', userId );
        }
    }
    else {
        console.log( res?.data.message ?? 'Unkown error.' );
    }
};
export type Logout = typeof logout;

export default logout;
